class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (event) => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (event.target === this || event.target === overlay) this.close();
    });
    this.setHeaderCartIconAccessibility();
  }

  // setHeaderCartIconAccessibility() {
  //   const cartLink = document.querySelector('#cart-icon-bubble');
  //   cartLink.setAttribute('role', 'button');
  //   cartLink.setAttribute('aria-haspopup', 'dialog');
  //   cartLink.addEventListener('click', (event) => {
  //     event.preventDefault();
  //     this.open(cartLink)
  //   });
  //   cartLink.addEventListener('keydown', (event) => {
  //     if (event.code.toUpperCase() === 'SPACE') {
  //       event.preventDefault();
  //       this.open(cartLink);
  //     }
  //   });
  // }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble-safe');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  hideQtyForFreeItems() {
    this.querySelectorAll('.cart-item').forEach(item => {
      const priceEl = item.querySelector('.cart-item__price-wrapper .price');
      const qtyWrapper = item.querySelector('.cart-item__quantity-wrapper');

      if (!priceEl || !qtyWrapper) return;

      // Parse European format: €0,00 → 0
      const priceText = priceEl.textContent.trim();
      const normalized = priceText.replace(/[^0-9,]/g, '').replace(',', '.');
      const isFree = parseFloat(normalized) === 0;

      if (isFree) {
        qtyWrapper.style.visibility = 'hidden';
        qtyWrapper.style.pointerEvents = 'none';
      } else {
        qtyWrapper.style.visibility = '';
        qtyWrapper.style.pointerEvents = '';
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    this.classList.remove('closed-overlay');
    setTimeout(() => { this.classList.add('animate', 'active'); this.hideQtyForFreeItems(); }, 0);

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      // trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    // console.log('here')
    if (window.timer_) {
    } else {
      window.timer_ = true;
      var countdown = 10 * 60 * 1000; // 10 minutes in milliseconds
      // var timerId = setInterval(function () {
      //   countdown -= 1000;
      //   var min = Math.floor(countdown / (60 * 1000));
      //   var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
      //   var display = min + ':' + (sec < 10 ? '0' : '') + sec;
      //   jQuery('#timer').text(display);
      //   if (countdown <= 0) {
      //     clearInterval(timerId);
      //     window.location.href = '/checkout'
      //   }
      // }, 1000);
    }
  }

  close() {
    this.classList.remove('active');
    this.classList.add('closed-overlay');
    // Globally close all upsell popups to ensure they don't persist
    document.querySelectorAll('.product-popups').forEach(popup => {
      popup.classList.remove('active');
    });

    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    if (this.querySelector('.drawer__inner')) this.querySelector('.drawer__inner').classList.remove('is-empty');
    if (this.querySelector('cart-drawer-items')) this.querySelector('cart-drawer-items').classList.remove('is-empty');

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      try {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const html = parsedState.sections[section.section || section.id];
        if (sectionElement && html) {
          const innerHTML = this.getSectionInnerHTML(html, section.selector);
          if (innerHTML) {
            sectionElement.innerHTML = innerHTML;
          }
        }
      } catch (e) {
        console.error('Error updating section:', section.id, e);
      }
    }));

    setTimeout(() => {
      try {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.open();
      } catch (e) {
        console.error('Error opening drawer:', e);
      }
      this.hideQtyForFreeItems();

      // ── SCROLL TO TOP after re-render ──
      requestAnimationFrame(() => {
        const sc = this.querySelector('.cart-scroll-container');
        if (sc) sc.scrollTo({ top: 0, behavior: 'instant' });
      });
    }, 0);

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      if (window.updateShippingBar) window.updateShippingBar(cart);
    })
    .catch(err => console.error('Cart fetch error:', err));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    let el = doc.querySelector(selector);

    // Explicit fallback for known selectors
    if (!el && selector === '#CartDrawer') {
      el = doc.querySelector('cart-drawer');
    }

    // Generic fallback: try finding by tag name
    if (!el && selector) {
      const tagName = selector.replace(/[#.]/g, '').toUpperCase();
      el = Array.from(doc.body.children).find(child => child.tagName === tagName);
    }

    if (!el) {
      // Last resort: return body content if we suspect the wrapper is stripped
      if (selector === '#CartDrawer' || selector === 'cart-drawer') return doc.body.innerHTML;

      console.warn('Selector', selector, 'not found in section HTML');
      return null;
    }
    return el.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble-safe',
        section: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble-safe',
        section: 'cart-icon-bubble'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
